const comments = [
  {
    name: '追剧达人小明',
    time: '2小时前',
    rating: 5,
    content: '黄瓜影院真的太良心了！追了好几个平台的剧，最后还是回来这里看。画质高清、更新快，而且真的不缓冲，强烈推荐给所有爱追剧的朋友！',
    show: '暗夜追光',
  },
  {
    name: '电影控小花',
    time: '昨天',
    rating: 5,
    content: '作为一个电影爱好者，黄瓜影院的电影大全片库让我很惊喜。很多冷门佳片都能找到，高清画质即点即播，智能推荐还帮我发现了几部之前没注意到的好片子。',
    show: '星际迷途3',
  },
  {
    name: '熬夜看剧的阿强',
    time: '3天前',
    rating: 4,
    content: '用了快半年了，真心觉得不错。电视剧全集更新速度很快，基本热门剧播完当天就能看到完整版。就是希望片库能再多一些老剧资源，不过整体体验已经很满意了。',
    show: '长安浮生录',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            观众评价
          </h2>
          <p className="text-sm text-foreground-500">来自真实观众的使用反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i
                    key={j}
                    className={`ri-star-fill text-sm ${
                      j < comment.rating ? 'text-accent-500' : 'text-background-300'
                    }`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{comment.content}"
              </p>

              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-bold text-primary-600">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">
                    正在看《{comment.show}》 · {comment.time}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}